module.exports = __webpack_public_path__ + "img/9788983716156.96bfc9c8.jpg";